import { toRefs, reactive, watch, toRaw } from "vue"
import axios from "axios"
import { auth, app, firestore } from "./firebase"


import { doc, setDoc, addDoc, getDoc, collection, query, where, getDocs, onSnapshot, deleteDoc } from "firebase/firestore"
import config from "../../config"
import authenticationService from "./authenticationService"




export default function (collectionName, options) {

    const unsubscribeHandles = []

    const state = reactive({
        error: null,
        document: null
    })


    async function teardown() {
        for (let unsubscribeHandle of unsubscribeHandles) {
            await unsubscribeHandle()
        }
        unsubscribeHandles.length = 0
        state.document = null
    }


    async function load() {

        await teardown()

        let userId = authenticationService.user && authenticationService.user.value && authenticationService.user.value.uid ? authenticationService.user.value.uid : null

        if (!userId) {
            console.error('no userId', userId)
            return
        }
        console.log('authenticationService', JSON.stringify(authenticationService))
        let companyId = authenticationService.companyId ? authenticationService.companyId.value : null
        if (!companyId) {
            console.error('no companyId', companyId)
            return
        }

        const docRef = doc(firestore, collectionName, companyId)
        // const docSnap = await getDoc(docRef)


        let unsubscribeHandle = onSnapshot(docRef, (doc) => {
            let data = doc.data()
            state.document = data ? data : null
        })
        unsubscribeHandles.push(unsubscribeHandle)
    }

    async function saveDocument(document) {

        let userId = authenticationService.user && authenticationService.user.value && authenticationService.user.value.uid ? authenticationService.user.value.uid : null

        if (!userId) {
            console.error("saveEntry no userId")
            teardown()
            return
        }
        // document.uid = userId

        let companyId = authenticationService.companyId ? authenticationService.companyId.value : null
        if (!companyId) {
            console.error('no companyId', companyId)
            return
        }
        document.id = userId


        let data = structuredClone(toRaw(document))
        // let data = JSON.parse(JSON.stringify(document))
        delete data.id

        try {

            if (options && options.restUrl) {
                let token = await auth.currentUser.getIdToken()

                //make sure the url has all / needed
                let url = '' + config.url
                if (!url.endsWith('/')) {
                    url = url + '/'
                }
                if (url.endsWith('/') && options.restUrl.startsWith('/')) {
                    url = url.slice(0, -1) //remove the last char : /
                }

                url = url + options.restUrl
                if (!url.endsWith('/')) {
                    url = url + '/'
                }

                let response = await axios.post(url + (document.id ? document.id : ''), data, {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                })
                if (!response || !response.data) {
                    throw new Error("incomplete return value")
                }
                console.log('response', response)
                return response.data && response.data.id ? response.data.id : null

            } else {
                const entryRef = document.id ? doc(firestore, collectionName, document.id) : doc(collection(firestore, collectionName))
                setDoc(entryRef, data, { merge: true })
            }


        } catch (error) {
            throw error
        }
    }


    async function deleteDocument() {
        let companyId = authenticationService.companyId ? authenticationService.companyId.value : null
        if (!companyId) {
            console.error('no companyId', companyId)
            return
        }
        await deleteDoc(doc(firestore, collectionName, companyId))
    }


    watch(authenticationService.companyId, async (companyId) => {
        if (companyId) {
            load()
        } else {
            teardown()
        }
    }, { immediate: true })
    
    return {
        ...toRefs(state),
        teardown,
        deleteDocument,
        saveDocument,
    }
}